var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Validators, Wait } from '@gower/utils';
import classNames from "classnames";
import { setupRegex, testRegex } from './Mask';
import { defaultCenterClasses, defaultInputClasses, defaultTextAreaRootClasses } from './text-input.config';
import { CUIT_ERROR, DNI_ERROR, EMAIL_ERROR, LENGTH_ERROR, MAX_LENGTH_ERROR, MIN_LENGTH_ERROR, REQUIRED_ERROR, } from './text-input.error';
import { BottomContent, LeftContent, RightContent, TopContent, } from './text-input.content';
import { theme } from '../theme';
export var TextAreaInput = React.forwardRef(function (props, ref) {
    props = __assign(__assign({}, theme.current.TextAreaInputProps), props);
    return _jsx(TextAreaInputField, __assign({ ref: ref }, props));
});
var TextAreaInputField = React.forwardRef(function (_a, ref) {
    var _b;
    var mask = _a.mask, _c = _a.type, type = _c === void 0 ? 'text' : _c, email = _a.email, cuit = _a.cuit, dni = _a.dni, password = _a.password, showPasswordToogle = _a.showPasswordToogle, text = _a.text, numeric = _a.numeric, _d = _a.passwordVisible, passwordVisible = _d === void 0 ? false : _d, onPasswordVisible = _a.onPasswordVisible, passwordButtonProps = _a.passwordButtonProps, value = _a.value, onChange = _a.onChange, onChangeText = _a.onChangeText, _e = _a.onChangeMode, onChangeMode = _e === void 0 ? 'delayed' : _e, delayed = _a.delayed, noDelayed = _a.noDelayed, _f = _a.delayedTime, delayedTime = _f === void 0 ? 300 : _f, _g = _a.className, className = _g === void 0 ? '' : _g, style = _a.style, _h = _a.variant, variant = _h === void 0 ? 'outlined' : _h, _j = _a.inputSize, inputSize = _j === void 0 ? 'normal' : _j, filled = _a.filled, outlined = _a.outlined, solo = _a.solo, borderless = _a.borderless, border = _a.border, small = _a.small, normal = _a.normal, large = _a.large, _k = _a.rounded, rounded = _k === void 0 ? false : _k, _l = _a.errored, errored = _l === void 0 ? false : _l, suffix = _a.suffix, prefix = _a.prefix, label = _a.label, hint = _a.hint, error = _a.error, contentLeft = _a.contentLeft, contentRight = _a.contentRight, contentTop = _a.contentTop, contentBottom = _a.contentBottom, labelProps = _a.labelProps, hintProps = _a.hintProps, suffixProps = _a.suffixProps, prefixProps = _a.prefixProps, errorProps = _a.errorProps, clearable = _a.clearable, clearableOnEscape = _a.clearableOnEscape, clearableProps = _a.clearableProps, onClear = _a.onClear, selectAllOnFocus = _a.selectAllOnFocus, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onFocus = _a.onFocus, onBlur = _a.onBlur, onEnterDown = _a.onEnterDown, onEnterUp = _a.onEnterUp, onEscapeDown = _a.onEscapeDown, onEscapeUp = _a.onEscapeUp, readOnly = _a.readOnly, disabled = _a.disabled, loading = _a.loading, required = _a.required, minLength = _a.minLength, validate = _a.validate, errorTime = _a.errorTime, onValidateError = _a.onValidateError, maxLength = _a.maxLength, requiredLength = _a.requiredLength, showCounter = _a.showCounter, height = _a.height, maxHeight = _a.maxHeight, minHeight = _a.minHeight, noFocuseable = _a.noFocuseable, props = __rest(_a, ["mask", "type", "email", "cuit", "dni", "password", "showPasswordToogle", "text", "numeric", "passwordVisible", "onPasswordVisible", "passwordButtonProps", "value", "onChange", "onChangeText", "onChangeMode", "delayed", "noDelayed", "delayedTime", "className", "style", "variant", "inputSize", "filled", "outlined", "solo", "borderless", "border", "small", "normal", "large", "rounded", "errored", "suffix", "prefix", "label", "hint", "error", "contentLeft", "contentRight", "contentTop", "contentBottom", "labelProps", "hintProps", "suffixProps", "prefixProps", "errorProps", "clearable", "clearableOnEscape", "clearableProps", "onClear", "selectAllOnFocus", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "onEnterDown", "onEnterUp", "onEscapeDown", "onEscapeUp", "readOnly", "disabled", "loading", "required", "minLength", "validate", "errorTime", "onValidateError", "maxLength", "requiredLength", "showCounter", "height", "maxHeight", "minHeight", "noFocuseable"]);
    if (delayed)
        onChangeMode = 'delayed';
    if (noDelayed)
        onChangeMode = 'normal';
    if (filled)
        variant = 'filled';
    else if (solo)
        variant = 'solo';
    else if (borderless)
        variant = 'borderless';
    else if (border)
        variant = 'border';
    else if (outlined)
        variant = 'outlined';
    if (small)
        inputSize = 'small';
    else if (large)
        inputSize = 'large';
    else if (normal)
        inputSize = 'normal';
    if (password)
        type = 'password';
    else if (text)
        type = 'text';
    else if (numeric)
        type = 'text';
    else if (email)
        type = 'text';
    else if (cuit)
        type = 'text';
    else if (dni)
        type = 'text';
    var delayedEmitter = React.useRef(null);
    var errorTimeout = React.useRef(null);
    var forwardRef = React.useRef(null);
    var formatedMaskTests = setupRegex(mask);
    var _m = React.useState(evalMask(value || '')), internalValue = _m[0], setInternalValue = _m[1];
    var _o = React.useState(error || ''), internalError = _o[0], setInternalError = _o[1];
    var _p = React.useState(passwordVisible), isPasswordVisible = _p[0], setPasswordVisible = _p[1];
    React.useEffect(function () { if (ref) {
        if (typeof ref === "function") {
            ref(forwardRef.current);
        }
        else {
            ref.current = forwardRef.current;
        }
    } });
    React.useEffect(function () {
        setPasswordVisible(passwordVisible);
    }, [passwordVisible]);
    React.useEffect(function () {
        setInternalValue(evalMask(value || ''));
    }, [value]);
    React.useEffect(function () {
        setInternalError(error);
    }, [error]);
    var filledValue = Boolean(internalValue);
    if (password)
        type = isPasswordVisible ? 'text' : 'password';
    function rootOnClick(event) {
        internalOnFocus(event);
    }
    function internalOnChange(event, force) {
        if (force === void 0) { force = false; }
        clearError();
        var value = event.target.value;
        if (formatedMaskTests.length) {
            var inputValue = String(internalValue || '');
            if (inputValue.length > value.length) {
                var cursorIndex_1 = forwardRef.current.selectionStart;
                event.target.value = evalMask(value);
                emitChanges(event, force);
                Wait(50).then(function () {
                    forwardRef.current.selectionStart = cursorIndex_1;
                    forwardRef.current.selectionEnd = cursorIndex_1;
                });
            }
            else {
                event.target.value = evalMask(value);
            }
        }
        setInternalValue(value);
        emitChanges(event, force);
    }
    function evalMask(value, select) {
        if (select === void 0) { select = false; }
        if (formatedMaskTests.length) {
            var _a = testRegex(value, formatedMaskTests), text_1 = _a.text, charsPassed = _a.charsPassed;
            if (select) {
                forwardRef.current.selectionStart += charsPassed;
            }
            return text_1;
        }
        return value;
    }
    function emitChanges(event, force) {
        if (force === void 0) { force = false; }
        if (onChangeMode === 'normal' || force) {
            onChange && onChange(event);
            onChangeText && onChangeText(event.target.value);
        }
        else if (onChangeMode === 'delayed') {
            if (delayedEmitter.current)
                clearTimeout(delayedEmitter.current);
            delayedEmitter.current = setTimeout(function () { internalOnChange(event, true); }, delayedTime);
        }
    }
    function internalOnClear() {
        var _a, _b;
        var setValue = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
        setValue.call(forwardRef.current, '');
        (_a = forwardRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new Event('input', { bubbles: true }));
        (_b = forwardRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        onClear && onClear();
    }
    function internalOnFocus(event) {
        var _a, _b;
        (_a = forwardRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        if (selectAllOnFocus)
            (_b = forwardRef.current) === null || _b === void 0 ? void 0 : _b.select();
        onFocus && onFocus(event);
    }
    function internalOnBlur(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        var currentLen = (_b = (_a = forwardRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length;
        if (required && !((_c = forwardRef.current) === null || _c === void 0 ? void 0 : _c.value)) {
            setError(REQUIRED_ERROR);
        }
        else if (minLength > 0 && currentLen < minLength) {
            setError(MIN_LENGTH_ERROR(currentLen, minLength));
        }
        else if (maxLength > 0 && currentLen > maxLength) {
            setError(MAX_LENGTH_ERROR(currentLen, maxLength));
        }
        else if (requiredLength > 0 && currentLen != requiredLength) {
            setError(LENGTH_ERROR(currentLen, requiredLength));
        }
        else if (email && !Validators.Email((_d = forwardRef.current) === null || _d === void 0 ? void 0 : _d.value)) {
            setError(EMAIL_ERROR);
        }
        else if (cuit && !Validators.Cuit((_e = forwardRef.current) === null || _e === void 0 ? void 0 : _e.value)) {
            setError(CUIT_ERROR);
        }
        else if (dni && !Validators.Dni((_f = forwardRef.current) === null || _f === void 0 ? void 0 : _f.value)) {
            setError(DNI_ERROR);
        }
        else if (validate) {
            var error_1 = validate((_g = forwardRef.current) === null || _g === void 0 ? void 0 : _g.value);
            if (typeof error_1 === 'string') {
                setError(error_1);
            }
            else {
                clearError();
            }
        }
        else {
            clearError();
        }
        onBlur && onBlur(event);
    }
    function internalOnKeyUp(event) {
        if (event.key === 'Enter')
            onEnterUp && onEnterUp(event);
        if (event.key === 'Escape') {
            if (clearableOnEscape && filledValue) {
                internalOnClear();
                event.stopPropagation();
            }
            else {
                onEscapeUp && onEscapeUp(event);
            }
        }
        onKeyUp && onKeyUp(event);
    }
    function internalOnKeyDown(event) {
        if (event.key === 'Enter')
            onEnterDown && onEnterDown(event);
        if (event.key === 'Escape')
            onEscapeDown && onEscapeDown(event);
        onKeyDown && onKeyDown(event);
    }
    function tooglePasswordVisibility(visibility) {
        setPasswordVisible(visibility);
        onPasswordVisible && onPasswordVisible(visibility);
    }
    function setError(error) {
        setInternalError(error);
        if (errorTime) {
            if (errorTimeout.current)
                clearTimeout(errorTimeout.current);
            errorTimeout.current = setTimeout(function () { clearError(); }, errorTime);
        }
        onValidateError && onValidateError();
    }
    function clearError() {
        setInternalError('');
    }
    var rootClasses = classNames(defaultTextAreaRootClasses, (_b = {
            '__rounded': rounded
        },
        _b["__input_size_".concat(inputSize)] = true,
        _b["__input_variant_".concat(variant)] = true,
        _b), className);
    var centerClasses = classNames(defaultCenterClasses, {
        '__rounded': rounded,
        '__errored': errored || Boolean(internalError),
    }, className);
    return _jsx(_Fragment, { children: _jsxs("div", __assign({ className: rootClasses, style: style, onClick: rootOnClick }, { children: [_jsx(TopContent, { disabled: disabled || readOnly, label: label, size: inputSize, variant: variant, labelProps: labelProps, contentTop: contentTop }), _jsxs("div", __assign({ className: centerClasses }, { children: [_jsx(LeftContent, { prefix: prefix, size: inputSize, prefixProps: prefixProps, contentLeft: contentLeft }), _jsx("div", __assign({ className: defaultInputClasses }, { children: _jsx("textarea", __assign({ tabIndex: noFocuseable ? -1 : undefined, style: {
                                    height: height,
                                    maxHeight: maxHeight,
                                    minHeight: minHeight,
                                } }, props, { maxLength: maxLength || requiredLength, ref: forwardRef, readOnly: readOnly, disabled: disabled, value: internalValue, onChange: internalOnChange, onKeyUp: internalOnKeyUp, onKeyDown: internalOnKeyDown, onFocus: internalOnFocus, onBlur: internalOnBlur })) })), _jsx(RightContent, { password: password && showPasswordToogle, loading: loading, disabled: disabled || readOnly, filled: filledValue, suffix: suffix, size: inputSize, variant: variant, suffixProps: suffixProps, contentRight: contentRight, clearable: clearable, onClear: internalOnClear, clearableProps: clearableProps, isPasswordVisible: isPasswordVisible, tooglePasswordVisibility: tooglePasswordVisibility, passwordButtonProps: passwordButtonProps })] })), _jsx(BottomContent, { currentLength: (internalValue === null || internalValue === void 0 ? void 0 : internalValue.length) || 0, maxLength: maxLength, requiredLength: requiredLength, showCounter: showCounter, hint: hint, error: internalError, size: inputSize, hintProps: hintProps, errorProps: errorProps, contentBottom: contentBottom })] })) });
});
